<template>
  <div class="rdrs-lang-toggle notranslate" @click="toggleLang" :title="current === 'bn' ? 'Switch to English' : 'বাংলায় দেখুন'">
    <span class="rdrs-globe">🌐</span>
    <span class="rdrs-lang-label">{{ current === 'bn' ? 'English' : 'বাংলা' }}</span>
  </div>
</template>

<script>
export default {
  name: 'LanguageSwitcher',
  data() {
    return {
      current: 'en'
    };
  },
  mounted() {
    // Read from cookie on load
    this.current = this.getCookieLang();
    this.applyLang(this.current, false);
  },
  methods: {
    toggleLang() {
      const next = (this.getCookieLang() === 'bn') ? 'en' : 'bn';
      this.current = next;
      this.applyLang(next, true);
    },

    applyLang(lang, shouldReload) {
      // Update body class for CSS-based language styling
      document.body.classList.remove('lang-bn', 'lang-en');
      document.body.classList.add('lang-' + lang);

      // Set cookie
      const val = '/en/' + lang;
      document.cookie = 'googtrans=' + val + '; path=/';
      document.cookie = 'googtrans=' + val + '; path=/; domain=' + location.hostname;
      const parts = location.hostname.split('.');
      if (parts.length > 1) {
        document.cookie = 'googtrans=' + val + '; path=/; domain=.' + parts.slice(-2).join('.');
      }

      // Try combo directly
      const combo = document.querySelector('select.goog-te-combo');
      if (combo) {
        combo.value = lang;
        combo.dispatchEvent(new Event('change'));
        if (shouldReload) {
          setTimeout(() => { location.reload(); }, 400);
        }
        return;
      }

      // If combo not ready, wait then reload
      if (shouldReload) {
        let tries = 0;
        const iv = setInterval(() => {
          tries++;
          const c2 = document.querySelector('select.goog-te-combo');
          if (c2) {
            c2.value = lang;
            c2.dispatchEvent(new Event('change'));
            clearInterval(iv);
            setTimeout(() => { location.reload(); }, 400);
          } else if (tries > 8) {
            clearInterval(iv);
            location.reload();
          }
        }, 200);
      }
    },

    getCookieLang() {
      const m = document.cookie.match(/(?:^|;)\s*googtrans=([^;]*)/);
      if (m) {
        const v = decodeURIComponent(m[1]);
        if (v.indexOf('/bn') !== -1) return 'bn';
      }
      return 'en';
    }
  }
}
</script>

<style scoped>
.rdrs-lang-toggle {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  background: rgba(255,255,255,0.15);
  border: 1px solid rgba(255,255,255,0.4);
  border-radius: 20px;
  padding: 4px 14px;
  color: #ffffff !important;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  user-select: none;
  transition: background 0.2s;
}
.rdrs-lang-toggle:hover {
  background: rgba(255,255,255,0.28);
}
.rdrs-globe {
  font-size: 15px;
}
.rdrs-lang-label {
  color: #ffffff !important;
}
</style>

<style>
/* Hide Google Translate banner globally */
.goog-te-banner-frame, iframe.skiptranslate,
iframe[class*="goog"], iframe[src*="translate.google"],
.VIpgJd-Z1Dxnd-O96Twb-Lg2fx, #goog-gt-tt,
.goog-te-balloon-frame, .goog-te-gadget,
.goog-te-spinner-pos, .goog-tooltip {
  display: none !important;
  visibility: hidden !important;
  height: 0 !important;
  width: 0 !important;
  opacity: 0 !important;
  pointer-events: none !important;
}
html, body {
  top: 0px !important;
  margin-top: 0px !important;
  padding-top: 0px !important;
}
.goog-text-highlight {
  background-color: transparent !important;
  box-shadow: none !important;
}
</style>
